import { getDaysDifference } from '@utils/date/get-days-difference';
import dayjs from 'dayjs';

const isDateInTheFuture = (date) => {
  const days = getDaysDifference(dayjs(), dayjs(date));
  return days >= 0;
};

export { isDateInTheFuture };
